import { render, staticRenderFns } from "./FifthScreen.vue?vue&type=template&id=57b7a212&scoped=true&"
import script from "./FifthScreen.vue?vue&type=script&lang=js&"
export * from "./FifthScreen.vue?vue&type=script&lang=js&"
import style0 from "./FifthScreen.vue?vue&type=style&index=0&id=57b7a212&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b7a212",
  null
  
)

export default component.exports